import { gql } from '@apollo/client';
import { cascoQuotationExtended, cascoQuotationBase } from 'features/insuranceDocument/queries/fragments';

export const INSURANCE_QUOTATIONS_LIST_QUERY = gql`
  query insuranceQuotationsList($documentId: Int!) {
    insuranceQuotationsList(documentId: $documentId) {
      ...cascoQuotationBase
      ...cascoQuotationExtended
    }
  }
  ${cascoQuotationBase}
  ${cascoQuotationExtended}
`;

export const INSURANCE_RISKS_QUERY = gql`
  query insuranceRisks {
    insuranceRisks {
      id
      name
      code
    }
  }
`;

export const CASCO_QUOTATION = gql`
  query cascoQuotation($quotationId: Int!) {
    cascoQuotation(quotationId: $quotationId) {
      ...cascoQuotationBase
      ...cascoQuotationExtended
    }
  }
  ${cascoQuotationBase}
  ${cascoQuotationExtended}
`;

export const INSURANCE_CONVENTIONS = gql`
  query insuranceConventions($insurerId: Int!, $insuranceTypeId: Int!) {
    insuranceConventions(insurerId: $insurerId, insuranceTypeId: $insuranceTypeId) {
      id
      code
      name
    }
  }
`;
